/**
 * Keeps the "Your order: N boxes = N bottles · price" line under the quantity field
 * in step with it, for products sold in boxes (snippets/pack-quantity-custom.liquid).
 * Listens on the enclosing form, because the quantity field is swapped out when
 * another pack size is chosen.
 */
if (!customElements.get('pack-quantity-custom')) {
  class PackQuantity extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;
      this.update = this.update.bind(this);
      this.form.addEventListener('input', this.update);
      this.form.addEventListener('change', this.update);
      this.update();
    }

    disconnectedCallback() {
      if (!this.form) return;
      this.form.removeEventListener('input', this.update);
      this.form.removeEventListener('change', this.update);
    }

    /**
     * Formats an amount in cents the way the store's money format does, by putting
     * it in place of the known amount in the template the snippet rendered.
     * @param {number} cents - Amount in cents.
     * @returns {string}
     */
    formatMoney(cents) {
      const amount = (cents / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      // Isolated so that on /ar the dot in "Dhs." stays with the currency.
      return `\u2066${this.dataset.money.replace('1,234,567.89', amount)}\u2069`;
    }

    update() {
      const input = this.form.querySelector('input[name="quantity"]');
      if (!input) return;
      const qty = Math.max(parseInt(input.value, 10) || 1, 1);
      const boxes = qty * Number(this.dataset.boxes);
      const pieces = qty * Number(this.dataset.pieces);
      const template = boxes === 1 ? this.dataset.one : this.dataset.other;

      this.querySelector('p').textContent = template
        .replace('[b]', boxes.toLocaleString('en-US'))
        .replace('[p]', pieces.toLocaleString('en-US'))
        .replace('[m]', this.formatMoney(qty * Number(this.dataset.price)));
    }
  }

  customElements.define('pack-quantity-custom', PackQuantity);
}
